import {
  Component, Input, OnInit, SecurityContext, ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-rich-text-presenter',
  templateUrl: './rich-text-presenter.component.html',
  styleUrls: [ './rich-text-presenter.component.scss' ],
  encapsulation: ViewEncapsulation.None,
})
export class RichTextPresenterComponent  {
  @Input() content: string;

  constructor(private sanitizer: DomSanitizer) {}

  get richTextHtml() {
    return this.sanitizer.bypassSecurityTrustHtml(this.content);
  }
}
